const CGV = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Conditions Générales d'Utilisation et de Vente
          </h1>
          
          <div className="text-center mb-8">
            <h2 className="text-xl font-semibold text-red-600">Nazaï Studio</h2>
          </div>

          <div className="space-y-6 text-gray-700">
            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">1. Introduction</h3>
              <p>
                En utilisant l'application Nazaï Studio, vous acceptez nos conditions. 
                Elles fixent les règles de réservation et d'utilisation.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">2. Services</h3>
              <p>
                Réservation de cours privés de coaching dans nos studios Plaza et Semlalia, 
                selon disponibilité.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">3. Réservations et Paiement</h3>
              <p>
                Les abonnements sont confirmés uniquement après paiement en ligne via CMI Maroc 
                ou en espèces dans le studio. Les prix sont affichés en MAD TTC.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">4. Annulation et Report</h3>
              <p>
                Vous pouvez reporter un cours jusqu'à 12h avant l'horaire prévu. 
                Toute absence ou annulation tardive est facturée.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">5. Pass et Abonnements</h3>
              <p>
                Chaque abonnement a une durée de validité. Les séances non utilisées sont perdues. 
                Les abonnements sont personnels et non transférables.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">6. Santé, Responsabilité et Assurance</h3>
              <p>
                Le client atteste être en bonne santé. Nazaï Studio n'est pas responsable en cas 
                de blessure liée à une mauvaise pratique. Le studio dispose d'une assurance 
                responsabilité civile professionnelle couvrant les dommages matériels ou corporels 
                dans ses locaux.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">7. Règlement Intérieur</h3>
              <p>
                Respect des horaires, tenue sportive adaptée, respect du personnel et des autres clients.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">8. Données Personnelles</h3>
              <p>
                Vos données (nom, téléphone, email) sont utilisées uniquement pour gérer 
                vos réservations et paiements.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">9. Modification des Conditions</h3>
              <p>
                Nazaï Studio peut modifier ces conditions à tout moment. Les mises à jour 
                sont communiquées dans l'application.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">10. Contact</h3>
              <p>
                <a 
                  href="mailto:hello@nazaistudio.ma" 
                  className="text-red-600 hover:text-red-700 font-medium"
                >
                  hello@nazaistudio.ma
                </a> – Nazaï Studio, Marrakech
              </p>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200 text-center">
            <p className="text-sm text-gray-500">
              Dernière mise à jour : Janvier 2025
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CGV;
